export const PREFERENCES_LOCAL_STORAGE_KEY = 'acadlyPreferences';
